import {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import { BiChevronDown, BiMessageAltDetail } from 'react-icons/bi';
import {
  BsEmojiSmile,
  BsMicFill
} from 'react-icons/bs';
import { ImMagicWand } from "react-icons/im";
import { IoClose, IoSend } from 'react-icons/io5';
import {
  MdOutlineAttachFile,
} from 'react-icons/md';
import { PiNotepad } from 'react-icons/pi';
import { toast } from 'react-toastify';
import {
  Alert,
  AnswerGeneration,
  AttachFiles,
  AutoResizeTextarea,
  Avatar,
  Comments,
  Countdown,
  Emoji,
  Messages,
  MessageTemplates,
  Modal,
  TextBalloon,
  VideoCallControls,
  VoiceRecorder
} from '../../components';
import { useChat } from '../../contexts/chat';
import {
  getMessages,
  getMessagesOld,
  getTimeExpireSession,
  sendDocumentByLink,
  sendFiles,
  sendMessage,
  sendMsgTemplate,
  sendMsgTemplateParams
} from '../../service/serviceChat/chatService';
import { closeCustomer } from '../../service/serviceChat/customerService';
import { maskPhone, maskZero } from '../../utils';
import {
  Actions,
  AreaMessagesGenerated,
  Body,
  CloseCustomerService,
  CommentsNotification,
  Container,
  Content,
  Controls,
  ExpandBox,
  Footer,
  GoUP,
  Header,
  Info,
  LoadCustomerServiceClose,
  LoadMoreSpinerLoading,
  Menu,
  RenderControls,
  RenderVoiceRecorder,
  SelectFile,
  Send,
  StyleEmoji,
  AccessibilityModalContent,
  VideoOptionsRow
} from './styled';
import { useVideoCall } from '../../contexts/videoCall';

export function Chat(props) {

  const { idChat, nameClient, customer, onToggleChatMode } = props;
  const {
    handleMyChats,
    resetChat,
    functionality,
    idUser,
    accessLevel
  } = useChat();

  const [commentsNotification, setCommentsNotification] = useState(
    {
      cont: 0,
      colorPriority: '#919191'
    }
  );
  const [timeToExpire, setTimeToExpire] = useState(0);
  const [isSenssionExpired, setIsSenssionExpired] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const [message, setMessage] = useState('');
  const [openBoxExpand, setOpenBoxExpand] = useState(false);
  const [switchAction, setSwitchAction] = useState(0);
  const [startVoiceRecorder, setStartVoiceRecorder] = useState(false);
  const [filesToUpload, setFilesToUpload] = useState(false);
  const [templateSelected, setTemplateSelected] = useState(false);
  const [messageList, setMessageList] = useState([]);
  const [loadingMore, setLoadingMore] = useState(false);
  const [notificationInChat, setNotificationInChat] = useState(false);
  const [loadingCloseCustomer, setLoadingCloseCustomer] = useState(false);
  const [lastMessage, setLastMessage] = useState({});
  const [messageInProgress, setMessageInProgress] = useState(false);
  const [confirmCloseCustomer, setConfirmCloseCustomer] = useState(false);
  const [allowSelection, setAllowSelection] = useState(false);
  const [messagesSelected, setMessagesSelected] = useState([]);
  const [generatedMessages, setGeneratedMessages] = useState();
  const [openEmoji, setOpenEmoji] = useState(false);
  const [openSpecialModal, setOpenSpecialModal] = useState(false);
  const refBody = useRef(null);
  const refGoUP = useRef(null);
  const refSelectFile = useRef(null);
  const refFirstAccessibilityItem = useRef(null);

  function reset() {
    setIsSenssionExpired(true);
    setCommentsNotification(
      {
        cont: 0,
        colorPriority: '#919191'
      }
    );
    setMessageInProgress(false);
    setOpenMenu(false);
    setMessage('');
    setFilesToUpload([]);
    setOpenBoxExpand(false);
    setSwitchAction(0);
  };

  const searchTimeToExpire = useCallback(async (phoneChat) => {
    const response = await getTimeExpireSession(phoneChat)
    if (response) return setTimeToExpire(response)
    return setTimeToExpire('0:00:00')
  }, []);
  const searchMessages = useCallback(async () => {
    return await getMessages(
      idChat,
      setMessageList,
      () => verificationOnScroll(),
    )
  }, [idChat]);

  useEffect(() => {
    reset();
    searchMessages(idChat);
  }, [idChat, searchMessages]);
  useEffect(() => {
    onToggleChatMode(openMenu)
  }, [openMenu, onToggleChatMode])
  useEffect(() => {
    if (!isSenssionExpired) return
    if (messageList.length <= 0 || !messageList) return
    if (
      messageList[messageList.length - 1].mi4u_message_id
      !== lastMessage?.mi4u_message_id
    ) {
      setLastMessage(messageList[messageList.length - 1])
      searchTimeToExpire(idChat);
    }
  }, [messageList]);
  useEffect(() => {
    if (filesToUpload.length === 0) {
      setOpenBoxExpand(false);
      setSwitchAction(0);
    }
  }, [filesToUpload]);
  // useEffect(() => {
  //   const shouldRenderInvite = customer
  //     && customer.link
  //     && customer.link !== 'NOT LINK';
  //   setRenderInvite(shouldRenderInvite);
  // }, [customer, setRenderInvite]);
  useEffect(() => {
    if (!allowSelection) {
      setMessagesSelected([]);
    }
  }, [allowSelection])

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'F1' && accessLevel?.includes('ACESSIBILIDADE')) {
        e.preventDefault();
        setOpenSpecialModal((prev) => !prev);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [accessLevel]);

  useEffect(() => {
    if (openSpecialModal && refFirstAccessibilityItem.current) {
      setTimeout(() => {
        refFirstAccessibilityItem.current.focus();
      }, 100);
    }
  }, [openSpecialModal]);

  function verificationOnScroll() {
    if (refBody.current && typeof refBody.current.scrollHeight !== 'undefined') {
      refBody.current.scrollTop = refBody.current.scrollHeight;
    } else {
      setNotificationInChat(true);
    }
  };
  function onScroll() {
    const scrollHeight = refBody.current.scrollHeight;
    const scrollTop = refBody.current.scrollTop;
    const clientHeight = refBody.current.clientHeight;
    const rest = scrollHeight - scrollTop - clientHeight;
    if (rest > 200) {
      refGoUP.current.style.display = 'flex'
    } else {
      refGoUP.current.style.display = 'none'
    }
  };
  function handleScrollToBottom() {
    refBody.current.scrollTop = refBody.current.scrollHeight;
    if (notificationInChat) {
      setNotificationInChat(false)
    }
  };
  async function handleLoadMoreMessages() {
    setLoadingMore(true);
    await getMessagesOld(
      idChat,
      setMessageList,
      () => setLoadingMore(false),
    )
  };
  const handleTemplateChange = (event) => {
    setTemplateSelected(event);
    setMessage(event?.textFormatted ? event.textFormatted : event.text)
  };
  function handleOpenTemplate() {
    if (2 === switchAction || switchAction === 0) {
      setOpenBoxExpand(!openBoxExpand);
    }
    if (filesToUpload.length > 0) {
      setFilesToUpload(false);
    }
    setSwitchAction(2);
  };
  function searchFile() {
    refSelectFile.current.value = ''
    refSelectFile.current.click();
  };
  function handleFileChange(files) {
    if (!files && filesToUpload.length <= 0) {
      setFilesToUpload(false);
    } else {
      if (filesToUpload.length > 0) {
        const newFiles = Object.values(files);
        const updatedFiles = [...filesToUpload];
        newFiles.forEach((newFile) => {
          const isDuplicate = updatedFiles.some(
            (file) => file.name === newFile.name && file.type === newFile.type
          );
          if (!isDuplicate) {
            updatedFiles.push(newFile);
          }
        });
        setFilesToUpload(updatedFiles);
      } else {
        setFilesToUpload(Object.values(files));
      }
      setOpenBoxExpand(true);
      setSwitchAction(1);
    };
  };
  const onChangeFiles = (event) => {
    if (isSenssionExpired) return
    handleFileChange(event?.target?.files);
  }
  const onPaste = (event) => {
    if (isSenssionExpired) return;
    const files = Array.from(event?.clipboardData?.files);
    if (files.length > 0) {
      event.preventDefault();
      handleFileChange(files);
    }
  };
  const onDrop = (event) => {
    if (isSenssionExpired) return
    event.preventDefault();
    handleFileChange(event?.dataTransfer?.files);
  }
  const onDragOver = (event) => {
    if (isSenssionExpired) return
    event.preventDefault();
  }
  const onVerificationMessage = (text) => {
    const regex = /^[\n\s]+$/;
    return !regex.test(text);
  };
  async function onSendMessageText(messageText) {
    const sucess = await sendMessage(
      idChat,
      'text',
      messageText,
      customer.id,
    )
    if (!sucess) {
      toast.error(
        `Erro ao Enviar Mensagem !`,
        {
          position: "top-center",
          theme: "colored",
        }
      );

      return false
    };
    return true
  };
  async function onSendMessageTemplates(template) {
    const isTemplateTextEmpty = !template?.text;
    const statusSend = isTemplateTextEmpty
      ? await sendMsgTemplateParams(
        idChat,
        template?.template.id,
        template?.parameters,
        customer.id
      )
      : await sendMsgTemplate(
        idChat,
        template?.id,
        customer.id
      );
    if (!statusSend.success) {
      toast.error(
        statusSend?.message,
        { position: "top-center", theme: "colored" }
      )
      return false
    }
    setTemplateSelected(false);
    return true;
  };
  const isTemplateDoc = (template) => {
    if (template?.tipo === "document" || template?.template?.tipo === "document") {
      return true
    }
    return false
  };
  async function onSendTemplateDocument(template) {
    const isTemplateParams = !template.text;
    const statusSendDoc = isTemplateParams
      ? await sendDocumentByLink(
        idChat,
        template?.parameters[0],
        template?.parameters[0].substring(template?.parameters[0].lastIndexOf("/") + 1),
        customer.id
      )
      : await sendDocumentByLink(
        idChat,
        template?.url,
        template?.nome_arquivo,
        customer.id
      )
    if (!statusSendDoc.success) {
      toast.error(
        statusSendDoc?.message,
        { position: "top-center", theme: "colored" }
      )
      return false;
    }
    setTemplateSelected(false);
    return true;
  };
  async function onSendFiles(files, message) {
    const status = await sendFiles(
      files,
      message,
      idChat,
      customer.id,
    );
    if (!status) {
      toast.error(
        'Error',
        { position: "top-center", theme: "colored" }
      )
      return false;
    };
    return true;
  };
  function handleSendNewMessage() {
    setOpenBoxExpand(false);
    setMessageInProgress(true);
    if (!onVerificationMessage(message)) {
      setMessage('');
      setMessageInProgress(false);
      return
    }
    if (isSenssionExpired
      || templateSelected.utiliza_botoes === true
      || templateSelected?.template?.utiliza_botoes === true
    ) {
      onSendMessageTemplates(templateSelected);
      setMessage('');
      setMessageInProgress(false);
      handleScrollToBottom();
      return
    }
    if (templateSelected && isTemplateDoc(templateSelected)) {
      onSendTemplateDocument(templateSelected)
    }
    if (filesToUpload && filesToUpload.length > 0) {
      if (filesToUpload.length === 1) {
        onSendFiles(filesToUpload, message);
      } else {
        if (message) {
          onSendMessageText(message);
        }
        onSendFiles(filesToUpload, '');
      }
      setFilesToUpload([]);
    } else if (message) {
      onSendMessageText(message);
    }
    setMessage('');
    handleScrollToBottom();
    setMessageInProgress(false);
  };
  const handleChange = (e) => {
    setMessage(e.target.value);
  };
  const onKeyUp = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      handleSendNewMessage();
    }
  };
  function handleCloseCustomerService() {
    if (functionality.includes('confirma_finalizar_atendimento')) {
      setConfirmCloseCustomer(true);
    } else {
      onCloseCustomerService();
    }
  };
  async function onCloseCustomerService() {
    setLoadingCloseCustomer(true);
    // if (parseInt(statusCall) === 0 && inVideoCall === idChat) {
    //   await closeVideoCall(customer.client_id)
    // }
    const successes = await closeCustomer(customer)
    if (!successes) {
      setLoadingCloseCustomer(false);
      return toast.error(
        `'Erro ao Finalizar atendimento !'`,
        {
          position: "top-center",
          theme: "colored",
        }
      );
    }
    handleMyChats()
    resetChat(true)
    return
  };
  const removeMessageInArray = (index) => {
    setMessagesSelected(prevArray => prevArray?.filter(item => Object.keys(item)[0] !== index));
  };
  const addMessageInArray = (index, text) => {
    setMessagesSelected(prevArray => {
      const newArray = [...prevArray, { [index]: text }];
      newArray.sort((a, b) => Object.keys(a)[0] - Object.keys(b)[0]);
      return newArray;
    });
  };
  const selectedMessage = (action, message) => {
    if (action) {
      addMessageInArray(message?.docMessage_id, message?.body);
    } else {
      removeMessageInArray(message?.docMessage_id);
    }
  };
  const onCloseMessagesGenerated = () => {
    setOpenBoxExpand(false)
    setSwitchAction(0);
    setGeneratedMessages([]);
  };
  const toViewMessagesGenerated = (msgGenerated) => {
    setGeneratedMessages(msgGenerated)
    setOpenBoxExpand(true);
    setSwitchAction(3);
  };
  const RenderMessagesGenerated = ({ msgGenerated }) => {
    return (
      <AreaMessagesGenerated>
        <div>
          <IoClose
            onClick={() => onCloseMessagesGenerated()}
            className='icClose'
          />
        </div>
        <div>
          {msgGenerated.length > 0 &&
            msgGenerated.map((message, index) => (
              <TextBalloon
                onClick={() => { setMessage(message.resposta) }}
                key={index}
                isUserSystem={true}
                text={message.resposta}
              />
            ))
          }
        </div>
      </AreaMessagesGenerated>
    )
  };

  const messagesElements = useMemo(() => {
    let prevMessageDate = null;
    return messageList?.reduce((elements, message) => {
      const element = (
        <Messages
          onChecked={(e) => {
            selectedMessage(e, message)
          }}
          openCheck={allowSelection}
          key={message?.docMessage_id}
          message={message}
          prevMessageDate={prevMessageDate}
        />
      );
      prevMessageDate = message.date;
      return elements.concat(element);
    }, []);
  }, [messageList, allowSelection]);

  const { openVideoCall, dataCall } = useVideoCall();

  const handleVideoCallClick = (callType) => {
    openVideoCall({
      callOption: callType,
      customer: customer
    });
    setOpenSpecialModal(false);
  };

  const isInCall = useMemo(() => {
    if (!customer?.link) return dataCall?.call?.status === 'IN_CALL' && dataCall?.customer?.id === customer?.id;
    try {
      const parsedCall = JSON.parse(customer.link);
      return parsedCall?.status === 'IN_CALL' || (dataCall?.call?.status === 'IN_CALL' && dataCall?.customer?.id === customer?.id);
    } catch (e) {
      return dataCall?.call?.status === 'IN_CALL' && dataCall?.customer?.id === customer?.id;
    }
  }, [customer, dataCall]);

  const openMenuNotation = () => {
    setOpenMenu(!openMenu)
  }

  const handleCopy = (text, label) => {
    navigator.clipboard.writeText(text);
    toast.info(`${label} copiado!`, {
      position: "top-center",
      autoClose: 2000,
      theme: "colored",
    });
  };

  return (
    <Container>
      <Content isOpen={openMenu} accessLevel={accessLevel}>
        <Header accessLevel={accessLevel}>
          <Info accessLevel={accessLevel}>
            <Avatar name={nameClient} width={'3rem'} height={'3rem'} />
            <div>
              <div className="name">
                {nameClient}
                <span className='phone'>
                  {maskPhone(idChat)}
                </span>
              </div>
              <div className='countdown'>
                {timeToExpire !== 0 &&
                  <Countdown
                    initialTime={timeToExpire}
                    onChange={(e) => setIsSenssionExpired(e)}
                  />
                }
              </div>
            </div>
          </Info>
          <Actions accessLevel={accessLevel}>
            {!isSenssionExpired && <VideoCallControls customerService={customer} />}
            <CommentsNotification
              color={commentsNotification?.colorPriority}
              accessLevel={accessLevel}
            >
              <div className='cont--'>
                {commentsNotification?.cont !== 0 &&
                  <span className='number--'>
                    {commentsNotification?.cont}
                  </span>
                }
              </div>
              <span className='comments--icon'>
                <PiNotepad
                  className='cursor--pointer'
                  title="Ver Anotações"
                  onClick={openMenuNotation}
                />
              </span>
            </CommentsNotification>
          </Actions>
        </Header>
        <Body
          ref={refBody}
          onScroll={() => onScroll()}
          onDragOver={onDragOver}
          onDrop={onDrop}
          accessLevel={accessLevel}
        >
          {messageList?.length > 199 &&
            <div id='btn-loadMore'>
              {!loadingMore
                ? <button onClick={() => handleLoadMoreMessages()}>
                  {'Carregar mais'}
                </button>
                : <LoadMoreSpinerLoading />
              }
            </div>
          }
          {messagesElements}
        </Body>
        <Footer disabled={0}>
          <GoUP ref={refGoUP} onClick={() => handleScrollToBottom()} accessLevel={accessLevel}>
            <BiChevronDown />
            {/* {notificationInChat &&
                <MdNotificationsActive className='icon--notifications' />
              } */}
          </GoUP>
          <ExpandBox openBoxExpand={openBoxExpand} accessLevel={accessLevel}>
            {switchAction === 1
              && (<AttachFiles
                files={filesToUpload}
                setFiles={setFilesToUpload}
              />)
            }
            {switchAction === 2
              && (<MessageTemplates
                className="messageTemplate"
                isTemplatesOpenSession={isSenssionExpired}
                onChange={(e) => handleTemplateChange(e)}
              />)
            }
            {switchAction === 3
              && (<RenderMessagesGenerated
                msgGenerated={generatedMessages}
              />)
            }
          </ExpandBox>
          <Controls isAllowSelection={allowSelection} accessLevel={accessLevel}>
            <div>
              <RenderControls isHidden={startVoiceRecorder ? 1 : 0}>
                <div className='ref--end'>
                  {!isSenssionExpired &&
                    <>
                      <span className='icon--'>
                        <MdOutlineAttachFile
                          title='Anexar Documentos'
                          onClick={() => {
                            searchFile()
                          }}
                        />
                      </span>
                      {functionality.includes('co_pilot') &&
                        (<span className='icon-- magicWand'>
                          <ImMagicWand
                            title='Gerar Mensagem'
                            onClick={() => setAllowSelection(!allowSelection)}
                          />
                        </span>)
                      }
                    </>
                  }
                  <span className='icon--'>
                    <BiMessageAltDetail
                      title='Mensagem Template'
                      onClick={() => {
                        handleOpenTemplate()
                      }}
                    />
                  </span>
                  <AutoResizeTextarea
                    style={{ maxHeight: openBoxExpand ? '120px' : '200px' }}
                    rows="1"
                    cols="30"
                    placeholder={
                      !isSenssionExpired
                        ? "Digite uma mensagem..."
                        : "Selecione um Template..."
                    }
                    value={message}
                    onChange={(e) => handleChange(e)}
                    onKeyUp={(e) => onKeyUp(e)}
                    disabled={(isSenssionExpired) ? true : false}
                    onPaste={(e) => onPaste(e)}
                  />
                  {
                    !isSenssionExpired && !startVoiceRecorder && (
                      <StyleEmoji>
                        <span
                          className='icon--'
                          title='Emoji'
                        >
                          <BsEmojiSmile
                            onClick={() => setOpenEmoji(true)}
                            style={{ pointerEvents: !openEmoji ? 'all' : 'none' }}
                          />
                        </span>
                        {openEmoji
                          && (<Emoji
                            onOutsideClick={() => setOpenEmoji(false)}
                            onEmojiSelect={(e) => { setMessage(prevMessage => prevMessage + e.native) }}
                          />)
                        }
                      </StyleEmoji>
                    )
                  }

                  {message || filesToUpload.length > 0
                    ? (
                      <Send
                        title='Enviar'
                        onClick={() => handleSendNewMessage()}
                      >
                        <IoSend />
                      </Send>
                    )
                    : (
                      <>
                        {
                          !isSenssionExpired && !startVoiceRecorder && (
                            <>
                              <span
                                className='icon--'
                                title='Gravar Áudio'
                                onClick={() => setStartVoiceRecorder(true)}
                              >
                                <BsMicFill />
                              </span>
                            </>
                          )
                        }
                        <CloseCustomerService
                          accessLevel={accessLevel}
                          disabled={isInCall}
                          title={isInCall ? 'Finalize a chamada para poder finalizar o atendimento' : ''}
                        >
                          {!loadingCloseCustomer
                            ? <button
                              className='close-customer-btn'
                              onClick={() => handleCloseCustomerService()}
                              disabled={isInCall}
                            >
                              {`Finalizar Atendimento \n ${maskZero(customer?.id)}`}
                            </button>
                            : <span className='load'>
                              <LoadCustomerServiceClose />
                            </span>
                          }
                        </CloseCustomerService>
                      </>
                    )
                  }
                </div>
              </RenderControls>
              <RenderVoiceRecorder isOpen={startVoiceRecorder}>
                <VoiceRecorder
                  start={startVoiceRecorder}
                  setStart={setStartVoiceRecorder}
                  to={idChat}
                  accessLevel={accessLevel}
                />
              </RenderVoiceRecorder>
              <SelectFile
                ref={refSelectFile}
                onChange={(e) => onChangeFiles(e)}
                multiple
              />
            </div>
            <div>
              <AnswerGeneration
                onClose={() => { setAllowSelection(false) }}
                messages={messagesSelected}
                onResponse={(response) => toViewMessagesGenerated(response)}
              />
            </div>
          </Controls>
        </Footer>
      </Content>
      <Menu isOpen={openMenu}>
        <Comments
          setCommentsNotification={setCommentsNotification}
          client={
            {
              id: customer?.client_id,
              number: idChat,
            }
          }
          idUser={idUser}
          allowCreation={true}
        />
      </Menu>
      <Alert
        isOpen={confirmCloseCustomer ? 1 : 0}
        title={`Finalizar Atendimento`}
        onClickOption1={
          () => {
            setConfirmCloseCustomer(false)
            onCloseCustomerService()
          }
        }
        onClickOption2={() => { setConfirmCloseCustomer(false) }}
      >
        <p>
          {`Deseja finalizar o atendimento
            ${maskZero(customer?.id)} ?
          `}
        </p>
      </Alert>
      {accessLevel?.includes('ACESSIBILIDADE') && (
        <Modal
          isOpen={openSpecialModal}
          close={() => setOpenSpecialModal(false)}
          title="ACESSIBILIDADE"
          zIndex={1000001}
        >
          <AccessibilityModalContent>
            <div className="item">
              <span className="label">Usuário {nameClient}</span>
              <button
                ref={refFirstAccessibilityItem}
                className="access-button"
                onClick={() => handleCopy(nameClient, "Nome")}
              >
                COPIAR NOME
              </button>
            </div>

            <div className="item">
              <span className="label">WhatsApp {idChat}</span>
              <VideoOptionsRow>
                <button
                  className="access-button"
                  onClick={() => handleCopy(idChat, "Número")}
                >
                  COPIAR NÚMERO
                </button>
                <button
                  className="access-button"
                  onClick={() => {
                    handleCopy(`https://wa.me/${idChat}`, "Link");
                    window.open(`https://wa.me/${idChat}`, "_blank");
                  }}
                >
                  ABRIR WHATSAPP
                </button>
              </VideoOptionsRow>
            </div>

            {!isSenssionExpired && dataCall?.call?.status !== 'IN_CALL' && (accessLevel?.includes('VIDEOCHAMADA_MI4U') || accessLevel?.includes('VIDEOCHAMADA_MEET')) && (
              <div className="item">
                <span className="label">Iniciar Chamada de Vídeo</span>
                <VideoOptionsRow>
                  {accessLevel?.includes('VIDEOCHAMADA_MI4U') && (
                    <button
                      className="access-button video-call-btn"
                      onClick={() => handleVideoCallClick('VIDEOCHAMADA_MI4U')}
                    >
                      VÍDEOCHAMADA
                    </button>
                  )}
                  {accessLevel?.includes('VIDEOCHAMADA_MEET') && (
                    <button
                      className="access-button video-call-btn meet-btn"
                      onClick={() => handleVideoCallClick('VIDEOCHAMADA_MEET')}
                    >
                      GOOGLE MEET
                    </button>
                  )}
                </VideoOptionsRow>
              </div>
            )}
          </AccessibilityModalContent>
        </Modal>
      )}
    </Container >
  );
}